
<template>
  <div>
      <div class="content">
        <lk-modal title="流转处方" v-model="showReadCard" :footer-hide='true' width="1100" @on-cancel="modalCancel">
        <div class="cardContent">
          <div class="infoTitle">
          <div style="margin-bottom: 16px">购药方式：自主购药</div>
        </div>
        <div class="cardBaseInfo" style="display:flex">
          <div class="cardLeft" style="display:flex">
            <div style="margin-right:16px">卡类型:</div>
            <div>
            <lk-radio-group v-model="cardType">
              <lk-radio v-for="item in cardList" :key="item.id" :label="item.id">
                <span>{{ item.name }}</span>
              </lk-radio>
            </lk-radio-group>
          </div>
        </div>
        <lk-form ref="insurance" :label-width="90" :model='QRcodeModel' :rules='QRcodeRule' v-if="cardType === 2" style="margin-top:-6px" >
          <lk-form-item label='医保卡：' prop="QRcode">
            <lk-input
            ref="QRcode"
            style="width:250px"
            v-model="QRcodeModel.QRcode"
            placeholder="请扫码电子医保二维码"
          ></lk-input>
          </lk-form-item>
        </lk-form>
        <lk-button
          type="primary"
          @click="handleReadCard"
          :disabled="cardStatus"
          :loading="btnCardLoading"
          style="margin-top:-5px; margin-left: 10px; width: 60px; height: 30px;"
          >
          读卡
        </lk-button>
      </div>
        </div>
        <lk-form :label-width='120' label-position="right">
            <lk-card title='' class="cardContainer" :bordered="false" style="background:#F3F7F9">
                <lk-row :gutter='16' style="background:#F3F7F9">
                  <lk-col span='8'><lk-form-item  label='社保卡卡号:'><span>{{cardInfoObj.icInfo.cardNo}}</span></lk-form-item></lk-col>
                  <lk-col span='8'><lk-form-item  label='医保应用号:'><span>{{cardInfoObj.icInfo.icNo}}</span></lk-form-item></lk-col>
                  <lk-col span='8'><lk-form-item  label='公民身份证号:'><span>{{cardInfoObj.icInfo.idNo}}</span></lk-form-item></lk-col>
                </lk-row>
                <lk-row :gutter='16' style="background:#F3F7F9">
                  <lk-col span='8'><lk-form-item  label='姓名:'><span>{{cardInfoObj.icInfo.personname}}</span></lk-form-item></lk-col>
                  <lk-col span='8'><lk-form-item label='性别:'><span>{{cardInfoObj.icInfo.sexName}}</span></lk-form-item></lk-col>
                  <lk-col span='8'><lk-form-item  label='出生日期:'><span>{{cardInfoObj.icInfo.birthdayStr}}</span></lk-form-item></lk-col>
                </lk-row>
                <lk-row :gutter='16' style="background:#F3F7F9">
                  <lk-col span='8'><lk-form-item  label='参保人员类别:'><span>{{cardInfoObj.icInfo.fundtypeName}}</span></lk-form-item></lk-col>
                </lk-row>
            </lk-card>
        </lk-form>
        <div class="infoButton">
            <lk-button type='primary' :disabled="searchDisabled" @click="handleSearchRecipe">查询处方</lk-button>
        </div>
      </lk-modal>
      </div>
    </div>
</template>
<script>

import bjInsurance from '../../services/bjInsurance';
import utils from '../../libs/utils';

export default {
  computed: {

  },
  props: {
    showRead: {
      type: Boolean,
    },
  },
  watch: {
    showRead(val) {
      this.showReadCard = val;
      if (val) {
        this.searchDisabled = true;
        this.cardInfoObj = { icInfo: {} };
        this.btnCardLoading = false;
        this.cardStatus = false;
      }
    },
  },
  data() {
    return {
      searchDisabled: true,
      showReadCard: this.showRead,
      btnCardLoading: false,
      cardStatus: false,
      QRcodeModel: {
        QRcode: '',
      },
      cardInfoObj: { icInfo: {} },
      QRcodeRule: {
        QRcode: [
          { required: true, message: '请扫码电子医保二维码', trigger: 'blur' },
        ],
      },
      cardType: 1,
      cardList: [
        {
          id: 1,
          name: '医保卡',
        },
        {
          id: 2,
          name: '电子医保卡',
        },
      ],
    };
  },
  methods: {
    modalCancel() {
      this.$emit('closeModal');
    },
    handleSearchRecipe() {
      this.$emit('handleSearchRecipe', this.cardInfoObj);
    },
    handleReadCard() {
      if (this.cardType === 1) {
        this.readCardRequest();
        return;
      }
      this.$refs.insurance.validate((valid) => {
        if (valid) {
          this.readCardRequest();
        } else {
          this.$Message.error('请按照要求填写!');
        }
      });
    },
    readCardRequest() {
      const params = {
        buymode: 1, // 1、自主购药， 2、外配处方购药
        multiclass: this.cardType,
        QRcode: this.QRcodeModel.QRcode,
      };
      this.btnCardLoading = true;
      bjInsurance.readCard(params)
        .then((res) => {
          this.btnCardLoading = false;
          if (res.data.status === 200) {
            this.$Message.success('读卡成功');
            this.cardInfoObj = res.data.data || {};
            this.searchDisabled = false;
            this.cardStatus = true;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          this.btnCardLoading = false;
          utils.handleError(err);
        });
    },
  },
};
</script>

<style scoped>
.content {
padding-top: 10px;
}
.cardContent {
  max-height: 480px;
  overflow: auto;
  margin-bottom: 16px;
  .infoTitle {
    align-items: center;
    display: flex;
    padding: 0 10px 10px 10px;
  }
  .btn-content {
    display: flex;
    justify-content: flex-end;
    padding: 0 10px 10px 10px;
  }
  .cardBaseInfo {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0 10px 10px 10px;
    .ivu-form-item {
      margin-bottom: 0;
    }
  }
}
.infoButton{
    margin-left: 970px;
    margin-top: 20px;
    >*{margin-right: 16px
  }
  }
</style>
